// src/pages/ThankYou.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/EduComponents/ThankYou.css'

const ThankYou = () => {
  return (
    <section className="thankyou-container">
      <Helmet>
        <title>Thank You | Strawket</title>
        {/* ✅ Meta Pixel Code (Facebook Tracking) */}
        <script>
          {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1544770686681316');
          fbq('track', 'PageView');`}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=1544770686681316&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      <div className="thankyou-content">
        <h1>Thank You for Booking!</h1>
        <p>Your demo has been successfully scheduled. We look forward to connecting with you.</p>
        <a href="/" className="home-btn">Back to Home</a>
      </div>
    </section>
  );
};

export default ThankYou;
